import { ColumnDef } from "@arelia-components/ui-atoms/data-grid";
import { RevenueType } from "@arelia-types/earnings";

export const API_ROUTE = "/api/earnings/performance";

export const performanceRevenueColumnConfig: ColumnDef[] = [{
  field: "date",
  headerName: "Date",
  width: "25%",
  editable: true,
  type: "date"
}, {
  field: "location",
  headerName: "Location",
  width: "35%",
  editable: true,
}, {
  field: RevenueType.Tips,
  headerName: "Tips",
  width: "15%",
  editable: true,
  type: "currency"
}, {
  field: RevenueType.Merch,
  headerName: "Merch",
  width: "15%",
  editable: true,
  type: "currency"
}, {
  field: "amount",
  headerName: "Fee",
  width: "15%",
  editable: true,
  type: "currency"
}];
